import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { GridItem as GridItem$2 } from './Grid.style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "columnSpan", "columnEnd", "columnStart"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GridItem = function GridItem(_ref) {
  var children = _ref.children,
    columnSpan = _ref.columnSpan,
    columnEnd = _ref.columnEnd,
    columnStart = _ref.columnStart,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(GridItem$2, _objectSpread(_objectSpread({}, rest), {}, {
    // @ts-ignore
    $columnSpan: columnSpan,
    $columnStart: columnStart,
    $columnEnd: columnEnd,
    children: children
  }));
};
var GridItem$1 = GridItem;

export { GridItem$1 as default };
//# sourceMappingURL=GridItem.js.map
